import ExhibitionEventTabs from './exhibition-event-tabs';

export default ExhibitionEventTabs;